module.exports = __webpack_public_path__ + "img/step6-a.6ecce629.png";